import * as React from 'react';

import { SelectionCard } from 'src/components/dataSourceSelection/SelectionCard';
import { DataSourceIcon } from 'src/components/resourceDialog/DataSourceIcon';
import { DataSourceOption } from 'src/constants/dataSourceTypeDescription';
import { getDataSourceCardTestId } from 'src/constants/testIds';
import { DataSource } from 'src/store/state/dataSources';
import * as copy from 'src/templates/copy';

export type ConnectionCardV2Props = {
  dataSource: DataSource | null;
  dataSourceType: string;
  isNewConnection?: boolean;
  onSelect: () => void;
};

export const ConnectionCardV2: React.VFC<ConnectionCardV2Props> = ({
  dataSource,
  dataSourceType,
  isNewConnection = false,
  onSelect,
}) => {
  const label = isNewConnection
    ? copy.components.virtualGraphPreviewDialog.connectionSelection
        .newConnection
    : dataSource?.id || '';

  const endpoint = dataSource?.options?.[DataSourceOption.ENDPOINT];

  const icon = (
    <DataSourceIcon
      altText={`${dataSourceType} icon`}
      dataSourceType={dataSourceType}
    />
  );

  // Use dataSource.id as the test ID for existing connections
  const testId = dataSource?.id
    ? getDataSourceCardTestId(dataSource.id)
    : undefined;

  return (
    <SelectionCard
      icon={icon}
      label={label}
      onSelect={onSelect}
      testId={testId}
      tooltipText={endpoint}
      variant={isNewConnection ? 'new' : 'default'}
    />
  );
};
